import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { ButtonDialog } from "../../../../components/button-dialog/ButtonDialog";
import { RouteManualTable } from "./RouteManualTable";
import "./editroute.scss";
export default class RouteManualTablePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      vehicle: { oid: -1, name: "Automático" },
    };
  }
 
  onChangeSelectedVehicle = (e) => {
    let vehicle = e.value;
    this.setState({ vehicle });
  };

  onConfirm = () => {
    const vehicle = this.state.vehicle.oid != -1 ? this.state.vehicle : null;
    const orderCodes = this.props.records.map((order) => {
      return order.code;
    });
    const pointStart =  null; 
    const payload = { pointStart, vehicle, orderCodes };
    this.props.onConfirm(payload);
  };

 
  
  render() {
    const footer = (
      <div>
        <ButtonDialog
          onClick={this.onConfirm}
          button={{
            title: "Confirmar",
            className: "lognex-btn-highlighted",
            iconClassName: "pi pi-check",
          }}
          dialog={{
            header: "Confirmação",
            modal: false,
            message: "Deseja realmente incluir as ordens da rota?",
          }}
        ></ButtonDialog>

        <button title="Cancelar" className="lognex-btn-danger" onClick={this.props.onHide}>
          <i className="pi pi-times"></i>
        </button>
      </div>
    );

    const columns = this.props.columns
      .filter((col) => col.field == "code" ||
        col.field == "pickup.virtualCD" ||
        col.field == "pickup.description" ||
        col.field == "delivery.description")
      .map((col) => {
        if (col.field == "code") {
          return <Column {...col} key={col.field} style={{ fontSize: "11px", width: "80px" }} />;
        } else if (col.field == "pickup.virtualCD") {
          return <Column {...col} key={col.field} style={{ fontSize: "11px", width: "80px" }} />;
        }
        return <Column {...col} key={col.field} style={{ fontSize: "11px" }} />;
      });
 
      let isDv = false
    if (this.props.records) {
      //adicionar os CDs das novas ordens, q serão inclusas
      this.props.records.forEach((ship) => {

        if (ship.type !== "pontoApoio") {
          isDv = ship.dv;
        }
      });
    }

    let vehicles =this.props.vehicles;  
    let vehiclesAux = [];
    vehicles.forEach((v) => {
      if (vehiclesAux.filter((h) => h.code === v.code).length == 0) {
        vehiclesAux.push({ ...v, label: v.name  });
      }
    });
 

    vehicles = [{ oid: -1, name: "Automático", label: "Automático" }, ...vehiclesAux];

    return (
      <Dialog
        className="content"
        header={"Criar uma rota manual"}
        footer={footer}
        visible={this.props.visible}
        style={this.props.style || { width: "55vw" }}
        modal={true}
        onHide={this.props.onHide}
      >
        <div style={{ minHeight: "300px" }}>
          <div className="p-grid">
            <div className="p-col-12 form-field-container">
              <h3>Criar rota manual com as ordens abaixo</h3>
            </div>
          </div>
          <div className="p-grid">
            {/* <div className="p-col-6 form-field-container">
              <label>Selecione o ponto inicial(CD)</label>
              <Dropdown
                placeholder="Selecione"
                value={this.state.virtualCD}
                dataKey={"key"}
                key={Math.random()}
                optionLabel="label"
                options={virtualCDs}
                onChange={this.onChangeSelectedCD}
              /> 
            </div>*/}
            <div className="p-col-6 form-field-container">
              <label>Selecione o tipo de Veículo</label>
              <Dropdown
                placeholder="Selecione"
                value={this.state.vehicle}
                dataKey={"oid"}
                key={Math.random()}
                optionLabel="label"
                options={vehicles}
                onChange={this.onChangeSelectedVehicle}
              />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-12 form-field-container">
              <label>Ordens</label>
              <RouteManualTable records={this.props.records} columns={columns} />
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}
